<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 구분 -->
    <h5 class="mt-7 mb-4"><i class="dot"></i> 구분</h5>
    <div class="grid grid-cols-1 xl:grid-cols-6">
      <div v-for="item in ['배치 전 검진', '배치 후 검진', '일반 검진', '특수 검진']" :key="item" class="p-2">
        <span v-if="isPrint"> {{ item }} </span>
        <vs-checkbox v-else :readonly="board.readonly" v-model="form.구분" :vs-value="item"> {{ item }} </vs-checkbox>
      </div>
    </div>

    <!-- 건강검진 현황 -->
    <h5 class="mt-7 mb-4"><i class="dot"></i> 건강검진 현황</h5>
    <div class="writeGridContainer">
      <div>
        <div>대상인원수</div>
        <span v-if="isPrint">{{ form.대상인원수 }}}</span>
        <number-input v-else :readonly="board.readonly" v-model="form.대상인원수" />
      </div>
      <div>
        <div>실시인원수</div>
        <span v-if="isPrint">{{ form.실시인원수 }}</span>
        <number-input v-else :readonly="board.readonly" v-model="form.실시인원수" />
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board ? board.readonly : false"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";

import { required } from "vuelidate/lib/validators";
import NumberInput from "@/components/NumberInput.vue";

export default {
  components: {
    NumberInput,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        구분: [],
        대상인원수: 0,
        실시인원수: 0,
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
